/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-11-15 11:36:57
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-12-21 20:27:22
 */
import Vue from "vue";
import VueRouter from "vue-router";
import { h5 } from "./h5"

const Layout = () => import("@/views/Layout");
// 精耕杯活动
const JgbHome = () => import("@/views/Jgb/voteModel/index.vue");
// 终评专题
const LastReview = () => import("@/views/Jgb/lastReview/list.vue");
// 精耕杯预告
const JgbHerald = () => import("@/views/Jgb/jgbHerald/index.vue");
// 颁奖专题
const AwardCeremony = () => import('@/views/Jgb/awardCeremony/home.vue')
// 往届回顾
const ReviewModelFirst = () => import('@/views/Jgb/reviewModel/first.vue')
const ReviewModelTwo = () => import('@/views/Jgb/reviewModel/two.vue')
const ReviewModelThree = () => import('@/views/Jgb/reviewModel/two.vue')
const ReviewModelFour = () => import('@/views/Jgb/reviewModel/two.vue')
const ReviewModelFive = () => import('@/views/Jgb/reviewModel/five.vue')

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/jgb-home",
    children: [
      {
        path: "/jgb-home",
        name: "JgbHome",
        component: JgbHome,
        meta: {
          title: "精耕杯活动",
        },
      },
      {
        path: "/last-review",
        name: "LastReview",
        component: LastReview,
        meta: {
          title: "终评专题",
        },
      },
      {
        path: "/jgb-herald",
        name: "JgbHerald",
        component: JgbHerald,
        meta: {
          title: "精耕杯预告",
        },
      },
      {
        path: "/award-ceremony",
        name: "AwardCeremony",
        component: AwardCeremony,
        meta: {
          title: "颁奖典礼",
        }
      },
      {
        path: "/review-model/one",
        name: "ReviewModelFirst",
        component: ReviewModelFirst,
        meta: {
          title: "往届回顾第一届",
        },
      },
      {
        path: '/review-model/two',
        name: 'ReviewModelTwo',
        component: ReviewModelTwo,
        meta: {
          title: "往届回顾第二届"
        }
      },
      {
        path: '/review-model/three',
        name: 'ReviewModelThree',
        component: ReviewModelThree,
        meta: {
          title: "往届回顾第三届"
        }
      },
      {
        path: '/review-model/four',
        name: 'ReviewModelFour',
        component: ReviewModelFour,
        meta: {
          title: "往届回顾第四届"
        }
      },
      {
        path: '/review-model/five',
        name: 'ReviewModelFive',
        component: ReviewModelFive,
        meta: {
          title: "往届回顾第五届"
        }
      },
    ],
  },
  h5
  
  
];
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  routes,
});

// 路由拦截
// router.beforeEach((to, from, next) => {
//   // 从本地中拿到loginStatus 用户信息
//   let user = window.localStorage.getItem("user");
//   // 设置2天后过期
//   let time = 86400000 * 2; // 86400000是一天的毫秒数
//   if (to.path == "/login") {
//     next();
//   } else {
//     // 除了登入页，全部都要判断是否是登入状态
//     if (user) {
//       // 获取登入时的时间戳
//       let oldTime = window.localStorage.getItem("loginTime");
//       // 获取当前时间
//       let thisTime = new Date().getTime();
//       if (thisTime - oldTime >= time) {
//         // 过期了,前往登入
//         next({ path: "/login", query: { redirect: to.fullPath } });
//       } else {
//         next();
//       }
//     } else {
//       // 否则去登入
//       next({ path: "/login", query: { redirect: to.fullPath } });
//     }
//   }
// });

export default router;
